<template>
	<transition name="booking-modal">
		<div
			:class="[cover ? 'booking-modal-mask__dark' : '', 'booking-modal-mask']"
		>
			<div
				:class="['booking-modal-wrapper', { center: center }]"
				@click.self="clickOutside"
			>
				<div
					:style="
						cover
							? { width: '100%', height: '100%' }
							: { maxWidth: `${maxWidth}px` }
					"
					:class="[
						'booking-modal-container',
						'booking-modal-container--' + alignment,
						'booking-modal-container--' + width
					]"
					@scroll="handleScroll"
				>
					<button
						v-if="!disableClose"
						class="booking-modal-close"
						@click="$emit('close')"
					>
						<span v-if="closeLinkText">{{ closeLinkText }}</span>
						<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path class="cls-1" d="M21.19 4.22l-1.41-1.41L12 10.59 4.22 2.81 2.81 4.22 10.59 12l-7.78 7.78 1.41 1.41L12 13.41l7.78 7.78 1.41-1.41L13.41 12l7.78-7.78z"/></svg>
					</button>
					<p v-if="heading" class="booking-modal-heading">{{ heading }}</p>
					<p v-if="text" class="booking-modal-text">{{ text }}</p>
					<div v-if="closeCta" class="booking-modal-buttons">
						<Button @click.native="$emit('close')" :color="'primary4'">
							{{ closeCtaText }}
						</Button>
						<slot name="buttons"></slot>
					</div>
					<slot></slot>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import Button from '../atoms/Button'

export default {
	name: 'Modal',
	components: {
		Button
	},
	props: {
		close: {
			type: Function,
			default: () => window.console.log('stänge')
		},
		disableClose: {
			type: Boolean,
			default: false
		},
		closeLinkText: {
			type: String,
			default: ''
		},
		maxWidth: {
			type: Number,
			default: 1200
		},
		width: {
			type: Number,
			default: 0
		},
		alignment: {
			type: String,
			default: 'left'
		},
		heading: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			default: ''
		},
		closeCta: {
			type: Boolean,
			default: false
		},
		closeCtaText: {
			type: String,
			default: ''
		},
		cover: {
			type: Boolean,
			default: false
		},
		center: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		clickOutside() {
			this.$emit('close')
		},
		handleScroll(event) {
			const priceOverviewElement = document.getElementById('price-overview')

			if (priceOverviewElement) {
				if (event.currentTarget.scrollTop > priceOverviewElement.offsetTop) {
					priceOverviewElement.classList.add('price-overview--sticky')
				} else {
					priceOverviewElement.classList.remove('price-overview--sticky')
				}
			}
		}
	},
	created() {}
}
</script>

<style scoped lang="scss">
.booking-modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: RGBA(84, 100, 130, 0.5);
	display: table;
	transition: opacity 0.3s ease;

	&__dark {
		background-color: RGBA(84, 100, 130, 1);
	}
}

.booking-modal-close {
	position: absolute;
	border: none;
	right: 20px;
	top: 20px;
	display: flex;
	background-color: RGBA(84, 100, 130, 0);
	padding: 0;
	cursor: pointer;
	&:focus {
		outline: none;
	}

	span {
		font-size: 18px;
		line-height: 18px;
		text-decoration: underline;
		padding-right: 7px;
	}

	svg {
		width: 20px;
		fill: $colorSecondary;
	}
}

.booking-modal-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100vh;

	&.center {
		@include for-phone-only {
			display: flex;
			position: relative;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			overflow-y: auto;
		}
	}

	@include for-phone-only {
		display: block;
		position: fixed;
		top: 10px;
		bottom: 10px;
		right: 10px;
		left: 10px;
		overflow-y: auto;
	}
}

.booking-modal-container {
	position: relative;
	display: inline-block;
	width: auto;
	padding: 20px;
	margin: 20px 30px;
	background-color: white;
	transition: all 0.3s ease;
	overflow-y: auto;
	max-height: 100%;
	box-sizing: border-box;

	// Scrollbar
	&::-webkit-scrollbar {
		width: 17px;
	}
	&::-webkit-scrollbar-track {
		background: #f1f1f1;
	}
	&::-webkit-scrollbar-thumb {
		background: #c1c1c1;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: #a8a8a8;
	}

	@include for-phone-only {
		margin: 0;
	}
	@include for-tablet-portrait-up {
		max-height: 75vh;
		padding: 20px 30px;
	}
	&--center {
		text-align: center;
	}

	&--100 {
		width: 100%;
	}
}

.booking-modal-heading {
	font-size: 22px;
	line-height: 30px;
	color: $colorPrimary8;
	margin-bottom: 10px;
}
.booking-modal-text {
	margin-bottom: 0;
}
.booking-modal-buttons {
	margin-top: 20px;
	button {
		margin-right: 10px;
	}
}

.booking-modal-enter {
	opacity: 0;
}

.booking-modal-leave-active {
	opacity: 0;
}

.booking-modal-enter .booking-modal-container,
.booking-modal-leave-active .booking-modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>

<style lang="scss">
@include for-phone-only {
	.booking-modal-container {
		.h3 {
			font-size: 21px;
		}

		.vhd-container:not(.desktop) .vhd-picker {
			width: 230px;
		}
	}
}
</style>
